var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vueMain",
    { attrs: { title: _vm.$t("buttons.users") } },
    [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "container-fluid" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "nav",
              { staticClass: "col-lg-2 pl-0 pr-0 sidebar hover-bg" },
              [
                _c(
                  "b-nav",
                  { staticClass: "nav-pills", attrs: { vertical: "" } },
                  [
                    _c("b-nav-item", { attrs: { to: "Users", active: "" } }, [
                      _c("i", { staticClass: "fa fa-users" }),
                      _vm._v(_vm._s(_vm.$t("buttons.users")))
                    ]),
                    _vm._v(" "),
                    _c("b-nav-item", { attrs: { to: "Settings" } }, [
                      _c("i", { staticClass: "fa fa-cog" }),
                      _vm._v(" " + _vm._s(_vm.$t("buttons.settings")))
                    ]),
                    _vm._v(" "),
                    _c("b-nav-item", { on: { click: _vm.logout } }, [
                      _c("i", { staticClass: "fa fa-sign-out" }),
                      _vm._v(" " + _vm._s(_vm.$t("buttons.logout")))
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-10 pr-0" }, [
              _c(
                "div",
                { staticClass: "card-header text-center border-bottom-0" },
                [
                  _c("h3", [_vm._v(_vm._s(_vm.$t("users.title")))]),
                  _vm._v(" "),
                  _c(
                    "b-btn",
                    {
                      directives: [
                        {
                          name: "b-modal",
                          rawName: "v-b-modal.AddUser",
                          modifiers: { AddUser: true }
                        }
                      ],
                      staticClass: "card-header-button",
                      attrs: {
                        "data-trackname": "AddUser",
                        variant: "primary"
                      },
                      on: { click: _vm.clearUserTable }
                    },
                    [
                      _vm._v(
                        "\n               " +
                          _vm._s(_vm.$t("users.addUser")) +
                          " "
                      ),
                      _c("i", { staticClass: "fa fa-plus" })
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-body" },
                [
                  _c("v-client-table", {
                    attrs: {
                      columns: _vm.columns,
                      data: _vm.users,
                      options: _vm.options
                    }
                  })
                ],
                1
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("user-form", {
        attrs: { userTable: _vm.user2Edit },
        on: { refreshUsers: _vm.getUsers, clearUser: _vm.clearUserTable }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Pages/Users/Index.vue?vue&type=template&id=f1973800&
// module id = null
// module chunks = 